<script lang="ts">
    import {Button, Divider, FileDropzone, FormField, RadioGroup, SnackbarContainer, TextField} from 'attractions';
    import {CopyIcon} from 'svelte-feather-icons';
    import Base64 from '../lib/Base64';
    import Clipboard from "../lib/Clipboard";

    enum Modes {
        Auto,
        Encode,
        Decode,
    }

    const modeItems = [
        {value: Modes.Auto, label: 'auto'},
        {value: Modes.Encode, label: 'encode'},
        {value: Modes.Decode, label: 'decode'},
    ];

    let value = "";
    let inputValue = "";
    let currentMode = Modes.Auto;

    function copyToClipboard() {
        Clipboard.copyTextToClipboard(value);
    }

    function valueUpdated(e) {
        if(currentMode === Modes.Auto)  {
            const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
            value = base64regex.test(e.detail.value) ? Base64.decodeString(e.detail.value) :  Base64.encodeString(e.detail.value);
        } else  {
            value = currentMode === Modes.Encode ? Base64.encodeString(e.detail.value) : Base64.decodeString(e.detail.value);
        }
    }

    function resetValue() {
        value = "";
        inputValue = "";
    }


    async function fileUpdated(e) {
        resetValue();
        if (e.detail && e.detail.files && e.detail.files[0]) {
            value = await Base64.encodeFile(e.detail.files[0]);
        }
    }
</script>
<h2>Base64 Encode/Decode</h2>
<SnackbarContainer let:showSnackbar>
    <form>
        <Divider text="Input"/>

        <FormField name="Modes" help="Select the mode of operation">
            <RadioGroup items={modeItems} name="modes" bind:value={currentMode} on:change={resetValue}/>
        </FormField>

        <FormField name="Input" help="Paste your text here">
            <TextField multiline bind:value={inputValue} on:input="{valueUpdated}"/>
        </FormField>
        {#if currentMode <= Modes.Encode}
            <FormField name="Input file" help="Drop or open a file (no upload, everything happens locally)">
                <FileDropzone max="1" on:change={fileUpdated}/>
            </FormField>
        {/if}
        <Divider text="Result"/>
        <FormField name="Result"}>
            <TextField readonly multiline bind:value/>
        </FormField>
        <FormField name="">
            <Button filled
                    on:click={() =>{ copyToClipboard(); showSnackbar({ props: { text: `copied ${value.length} chars to clipboard.`  } })}}><CopyIcon size="20" class="mr"/>&nbsp;Copy to clipboard</Button>
        </FormField>
    </form>


</SnackbarContainer>
